import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Stethoscope, Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { TID } from "@/lib/testIds";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(null); setLoading(true);
        try {
            await login(email, password);
            navigate("/dashboard");
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-base flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <Link to="/" className="flex items-center gap-2 justify-center mb-8">
                    <span className="w-10 h-10 rounded-xl bg-brand text-white flex items-center justify-center">
                        <Stethoscope size={18} />
                    </span>
                    <span className="font-display text-brand text-lg font-semibold">Clínica Fernandes</span>
                </Link>
                <div className="card-earthy">
                    <h1 className="font-display text-2xl font-medium text-brand mb-1">Entrar</h1>
                    <p className="text-sm text-muted-clinical mb-6">Acesse sua conta como médico, paciente ou cuidador.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="label-clinical">E-mail</label>
                            <input
                                data-testid={TID.auth.emailInput}
                                type="email"
                                autoComplete="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="input-clinical"
                                placeholder="voce@email.com"
                            />
                        </div>
                        <div>
                            <div className="flex items-center justify-between mb-1">
                                <label className="label-clinical mb-0">Senha</label>
                                <Link
                                    data-testid="forgot-password-link"
                                    to="/forgot-password"
                                    className="text-xs text-brand hover:underline"
                                >
                                    Esqueci minha senha
                                </Link>
                            </div>
                            <input
                                data-testid={TID.auth.passwordInput}
                                type="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="input-clinical"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && (
                            <div data-testid={TID.auth.error} className="text-sm text-[var(--status-danger)] bg-[var(--status-danger-bg)] border-l-4 border-[var(--status-danger)] p-3 rounded">
                                {error}
                            </div>
                        )}
                        <button data-testid={TID.auth.submitBtn} type="submit" disabled={loading} className="btn-primary w-full">
                            {loading && <Loader2 size={16} className="animate-spin" />}
                            Entrar
                        </button>
                    </form>
                    <div className="mt-6 text-center text-sm text-muted-clinical">
                        Não tem conta?{" "}
                        <Link data-testid={TID.auth.switchToRegister} to="/register" className="text-brand font-medium hover:underline">Criar conta</Link>
                    </div>
                </div>
                <div className="mt-6 text-xs text-center text-muted-clinical">
                    Esqueceu a senha? Use o link acima ou solicite ao administrador da clínica uma senha temporária.
                </div>
            </div>
        </div>
    );
}
